import { useMocks } from '../../shared/env';
import type { AuditHistoryGateway } from './AuditHistoryGateway';
import { HttpAuditHistoryGateway } from './HttpAuditHistoryGateway';
import { MockAuditHistoryGateway } from './MockAuditHistoryGateway';

export const auditHistoryGateway: AuditHistoryGateway = useMocks ? new MockAuditHistoryGateway() : new HttpAuditHistoryGateway();
export type { AuditHistoryGateway, ModuleAuditEvent } from './AuditHistoryGateway';
